import React from 'react'
import { NewAppLayout } from '@/components/new-ux/layout/NewAppLayout'
import { ClientsManagement } from "@/components/clients/ClientsManagement"

const Clients = () => {
  return (
    <NewAppLayout>
      <ClientsManagement />
    </NewAppLayout>
  )
}

export default Clients
